module.exports = __webpack_public_path__ + "media/video.bd785264.mp4";